<template>
  <div class="container_cm">
    <div class="main_cm">
      <div class="bh_cm">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/guidance' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>检测机构管理</el-breadcrumb-item>
          <el-breadcrumb-item>检测机构</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="top_cm">
        <!-- <div>
          <span>机构名称</span><el-input v-model="searchForm.mechanismBaseName" clearable placeholder="请输入机构名称"></el-input>
        </div>
        <div>
          <el-button class="mybtny" v-waves icon="el-icon-search" @click="toSearch">搜索</el-button>
          <el-button class="mybtny" v-waves icon="el-icon-refresh-right" @click="reset">重置</el-button>
          <el-button class="mybtny" v-waves icon="el-icon-edit" @click="addProject">新增</el-button>
        </div> -->
      </div>
      <div class="table_cm">
        <Table
          ref="multipleTable"
          v-loading="loading"
          :tableData="List"
          :pageSize='pageSize'
          :currentPage="pageIndex"
          :cloumns="cloumns"
          :totalNum="total"
          :pageFlag='true'
          :selection='false'
          @handleCurrentChange="handleCurrentChange"
        >
          <el-table-column
            prop="mechanismBaseName"
            label="机构名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="account"
            label="送检账号"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click.native.prevent="editClick(scope.row)">编辑</el-button>
              <!-- <el-button type="text" @click.native.prevent="stop(scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </Table>
      </div>
    </div>
    <!-- 新增规范库 -->
    <div>
      <el-dialog title="新增检测机构" center :visible.sync="addVisible" width="700px" v-if="addVisible" :close-on-click-modal="false">
        <addProject @cancel="cancel" @submit="submit"></addProject>
      </el-dialog>
    </div>
    <!-- 编辑项目 -->
    <div>
      <el-dialog title="编辑检测机构" center :visible.sync="editVisible" width="700px" v-if="editVisible" :close-on-click-modal="false">
        <editProject @cancel="cancelEdit" @submit="submit" :editData='editData'></editProject>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { GetList, addCompany, updateCompany, delCompany } from "@/api/mechanismMana.js";
import addProject from "./components/addProject";
import editProject from "./components/editProject";
import Table from "@/components/myTable";
export default {
  inject:['reload'],
  components: {
    addProject,
    editProject,
    Table,
  },
  data() {
    return {
      userInfo: '',
      List: [],
      cloumns: [],
      loading: false,
      pageIndex: 1, //默认当前页
      pageSize: 10, //每页显示数量
      total: 0, //总条数
      searchForm: {},
      addVisible: false, //新增项目弹窗
      editVisible: false, //编辑项目弹窗
      editData: '', //待编辑项目数据
    }
  },
  created() {
    this.userInfo = this.$store.state.user.userInfo;
  },
  mounted() {
    this.getStandardList();
  },
  methods: {
    getStandardList() {
      let params = {
        deptId: this.userInfo.deptId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        ...this.searchForm,
      };
      this.loading = true;
      GetList(params).then(res => {
        if (res.code == "200") {
          this.List = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg || "服务器连接失败");
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        this.$message.error(err.msg || err.message || "服务器连接失败");
      });
    },
    toSearch() {
      this.pageIndex = 1;
      this.getStandardList();
    },
    reset() {
      this.searchForm.mechanismBaseName = '';
    },
    // 点击页码操作
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getStandardList();
    },
    // 刷新
    refresh() {
      this.reload();
    },
    // 新增项目
    addProject() {
      this.addVisible = true;
    },
    // 编辑项目
    editClick(row) {
      let { account, mechanismBaseName, password, id } = row
      this.editData = {
        account,
        mechanismBaseName,
        password,
        id,
      }
      this.editVisible = true;
    },
    // 新增/编辑项目提交
    submit(data, isAdd) {
      if (isAdd) {
        let params = {
          ...data,
          isDeleted: 0
        }
        addCompany(params).then(res => {
          if (res.code == '200') {
            this.$message.success(res.msg);
            this.cancel();
            this.getStandardList();
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        updateCompany({ ...data }).then(res => {
          if (res.code == '200') {
            this.$message.success(res.msg);
            this.cancelEdit();
            this.getStandardList();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    // 新增取消
    cancel() {
      this.addVisible = false;
    },
    // 编辑取消
    cancelEdit() {
      this.editVisible = false;
    },
    // 停用
    stop(row) {
      this.$confirm('确定删除该机构吗?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let params = {
          id: row.id,
          isDeleted: 1
        }
        delCompany(params).then(res => {
          if (res.code == "200") {
            this.$message.success(res.msg)
            this.getStandardList()
          } else {
            this.$message.error(res.msg)
            this.getStandardList()
          }
        })
      }).catch(() => {});
    },
  },
}
</script>

<style lang="less" scoped>
.container_cm {
  width: 100%;
  height: calc(100% - 30px);
  padding: 15px 0;
  .main_cm {
    height: calc(100% - 82px);
    margin: 0 auto;
    .bh_cm {
      height: 20px;
      line-height: 20px;
    }
    .top_cm {
      margin: 10px 0;
      display: flex;
      justify-content: space-between;
      .el-input {
        width: 200px;
        margin: 0 20px;
      }
      .el-button {
        width: 140px;
        margin-left: 20px;
      }
      .el-select {
        margin: 0 20px;
      }
    }
    .table_cm {
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MechanismMana/index.vue